import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import { type LessonPage } from "../../../models"
import BootstrapButton from "../../../components/BootstrapButton"
import { css } from "vite-css-in-js"
import { onBeforeUnmount, ref } from "vue"

interface Props {
   lesson: LessonPage
   lastPage: boolean
   setPage(next: boolean): void
}

const pageStyles = css`
   display: flex;
   height: 100%;
   flex-direction: column;
   justify-content: center;
   align-items: center;
   margin: 0 2rem;

   h1 {
      margin-bottom: 0;
   }

   div.intro p {
      color: #00A89E;
      text-align: center;
   }

   iframe {
      width: 100%;
      height: auto;
      aspect-ratio: 16 / 9;
      margin-top: 1rem;
      margin-bottom: 4rem;
      max-width: 60rem;
      border: none;
   }

   button.next {
      width: 100%;
      margin-bottom: 1rem;
      padding: 1rem;
      border: none;
      font-size: 14px;
      border-radius: 30px;
      background-color: #00A89E;
      color: #6750A4;
      transition: 0.2s;
      cursor: pointer;
   }

   button.next:hover {
      background-color: #009187;
      transition: 0.2s;
   }

   button.back {
      width: 100%;
      margin-bottom: 1rem;
      padding: 1rem;
      border: none;
      font-size: 14px;
      border-radius: 30px;
      color: #00A89E;
      transition: 0.2s;
      cursor: pointer;
   }

   button.back:hover {
      background-color: #b4b4b4;
      transition: 0.2s;
   }

`

const PWALessonPage: ReactiveComponent<Props> = (props) => {
  
   const language = ref(document.documentElement.lang)

   const languageObserver = new MutationObserver(() => {
      language.value = document.documentElement.lang
   })

   languageObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
   })

   onBeforeUnmount(() => languageObserver.disconnect())

	return () => (
      <div class={pageStyles}>
         <h1>{props.lesson.name}</h1>
         <div class="intro" v-html={props.lesson.properties.introduction?.markup ?? ""}></div>
         <iframe allow="autoplay; fullscreen; picture-in-picture" allowfullscreen src={language.value === "de" && props.lesson.properties.germanVideoUrl?.length > 0 ? props.lesson.properties.germanVideoUrl[0]?.url : props.lesson.properties.videoUrl[0]?.url}></iframe>
         {!props.lastPage && (
            <BootstrapButton class="next" color="decider" onClick={() => props.setPage(true)}>Next</BootstrapButton>
         )}
         <BootstrapButton class="back" color="decider" onClick={() => props.setPage(false)}>Go Back</BootstrapButton>
      </div>
	)
}
export default defineComponent(PWALessonPage, inferProps<Props>())